'use client';

import {styled} from "@mui/system";
import {Box} from "@mui/material";

const DescriptionOverview = styled(Box)(({theme}) => ({
    width: '80%',
    margin: '0 auto',
    padding: '.5rem',
    color: theme.palette.custom?.darkGray,
    ' p' : {
        marginTop: 0,
        marginBottom: '1rem'
    },
    'a' : {
        color: theme.palette.custom?.link,
    },
    [theme.breakpoints.down('md')]: {
        margin: '0',
        width: '100%',
    },
}));

export default DescriptionOverview;
